module.exports = __webpack_public_path__ + "static/img/record-count.0e8e98b2.png";